export const products = {
  // Main Products Page
  mainHero: {
    title: "Ürünlerimiz",
    subtitle: "Premium kahve, çay ve içecek çözümlerimizi keşfedin"
  },

  // Coffee Section
  coffee: {
    title: "KAVRULMUŞ KAHVE",
    description: "En seçkin menşelerden temin edilen premium kavrulmuş kahve çekirdekleri",
    button: "Kahveleri Keşfet"
  },

  // Milkshakes Section
  milkshakes: {
    title: "MİLKSHAKE",
    description: "Her damak zevkine uygun, lezzetli ve kremamsı milkshake karışımları",
    button: "Milkshake’leri Keşfet"
  },

  // HoReCa Section
  horeca: {
    title: "HORECA ÇÖZÜMLERİ",
    description: "Otel, restoran ve kafeler için profesyonel ürünler",
    button: "HoReCa’yı Keşfet"
  },

  // Tea Section
  tea: {
    title: "ÇAY",
    description: "Premium çay seçkisi",
    button: "Çayları Keşfet",
    comingSoon: "Çok Yakında"
  },

  // Machines Section
  machines: {
    title: "KAHVE & ÇAY MAKİNELERİ",
    description: "Profesyonel demleme ekipmanları",
    button: "Makineleri Keşfet",
    comingSoon: "Çok Yakında"
  },

  // Roasted Coffee Page
  roastedCoffee: {
    hero: {
      title: "Kavrulmuş Kahve",
      subtitle: "Mükemmelliğe ulaşacak şekilde kavrulmuş premium kahve çekirdekleri",
      label: "KAHVE KOLEKSİYONU"
    },
    intro: {
      title: "Artizan Kavurma Ustalığı",
      description: "Kavrulmuş kahve koleksiyonumuz, kahve zanaatkârlığının zirvesini temsil eder. Dünyanın en seçkin kahve yetiştirme bölgelerinden özenle seçilen her çekirdek, kahve tutkunlarının değer verdiği özgün aroma ve tat profillerini ortaya çıkarmak için mükemmel şekilde kavrulur."
    },
    seeDetails: "Detayları Gör"
  },

  // Pods Page
  pods: {
    hero: {
      title: "Kahve Podları",
      subtitle: "Pratik tek kullanımlık kahve çözümleri",
      label: "ESE 44MM POD"
    },
    intro: {
      title: "Her Zaman Mükemmel Kahve",
      description: "Kahve podlarımız, tutarlı kalite ve kullanım kolaylığı sunar. Her bir pod, taze kavrulmuş kahvenin zengin aroma ve lezzetini koruyacak şekilde özenle hazırlanır ve her fincanda kusursuz bir deneyim sağlar."
    },
    seeDetails: "Detayları Gör"
  },

  // Capsules Page
  capsules: {
    hero: {
      title: "Uyumlu Kapsüller",
      subtitle: "Kahve makineniz için premium kapsüller",
      label: "UYUMLU KAPSÜLLER"
    },
    intro: {
      title: "Uyumluluk ve Kalitenin Buluşması",
      description: "Uyumlu kapsüllerimiz, popüler kahve makineleriyle kusursuz şekilde çalışacak biçimde tasarlanmıştır ve üstün lezzet sunar. Taviz vermeden premium kahve deneyimi yaşayın."
    },
    seeDetails: "Detayları Gör"
  },

  // Milkshakes Page
  milkshakesPage: {
    hero: {
      title: "Milkshake",
      subtitle: "Kremamsı ve lezzetli milkshake karışımları",
      label: "MİLKSHAKE KOLEKSİYONU"
    },
    intro: {
      title: "Keyif Veren Milkshake Deneyimi",
      description: "Milkshake koleksiyonumuz, her yaştan müşteriyi memnun eden zengin ve kremamsı lezzet çeşitleri sunar. Kafeler, restoranlar ve dondurmacılar için idealdir."
    },
    seeDetails: "Detayları Gör"
  },

  // HoReCa Page
  horecaPage: {
    hero: {
      title: "HoReCa Çözümleri",
      subtitle: "Konaklama sektörü için profesyonel ürünler",
      label: "PROFESYONEL ÇÖZÜMLER"
    },
    intro: {
      title: "Mutfak Yaratımlarınızı Yükseltin",
      description: "HoReCa ürün grubumuz, otel, restoran ve kafelerde profesyonel kullanım için özel olarak geliştirilmiştir. Pralinlerden soslara kadar her ürün, en yüksek kalite ve tutarlılık standartlarını karşılar."
    },
    categories: {
      pralines: "Pralinler",
      fillingCreams: "Dolgu Kremleri",
      fillingFruits: "Meyve Dolguları",
      toppingSauces: "Topping Soslar",
      decorSauces: "Dekor Soslar",
      coldGlazes: "Soğuk Glazeler",
      coffeeBarSauces: "Kahve Barı Sosları"
    },
    seeDetails: "Detayları Gör"
  },

  // Tea Page
  teaPage: {
    hero: {
      title: "Premium Çay Koleksiyonu",
      subtitle: "Çok Yakında",
      label: "ÇAY KOLEKSİYONU"
    },
    comingSoonText: "Rafine lezzette yeni bir bölüm",
    description: "Geleneklere saygı duyarken inovasyonu benimseyen özel bir çay koleksiyonu hazırlıyoruz. Olağanüstü bir deneyim için bizi takip edin."
  },

  // Machines Page
  machinesPage: {
    hero: {
      title: "Kahve & Çay Makineleri",
      subtitle: "Çok Yakında",
      label: "EKİPMAN"
    },
    comingSoonText: "Mükemmellik için profesyonel ekipmanlar",
    description: "Her fincanda kusursuzluk talep eden profesyoneller için tasarlanmış premium kahve ve çay makinelerinden oluşan bir seçki hazırlıyoruz."
  }
};
